<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { AddressContactTag } from "../../_shared/_logic/address-table-contract"

  let { rowId, tags = [] }: { rowId: string | number | undefined; tags?: AddressContactTag[] } =
    $props()
</script>

{#if tags.length}
  <div class="contact-tags">
    {#each tags as tag, index (`${rowId}-${tag.id}-${index}`)}
      <StatusTag
        variant="neutral"
        size="sm"
        label={tag.label}
        color={tag.color}
        tooltipContent={tag.tooltip}
        tooltipHtml={tag.tooltipHtml ?? false}
        tooltipClassName={tag.tooltipHtml ? RICH_TOOLTIP_CLASS : ""}
      />
    {/each}
  </div>
{:else}
  <span>–</span>
{/if}

<style lang="less">
  .contact-tags {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    align-items: flex-start;
  }
</style>
